import type {ChangeEvent, FC, HTMLProps} from 'react';
import {memo, useCallback} from 'react';

import classNames from 'classnames';

import styles from './Switch.module.css';

interface Props
  extends Omit<HTMLProps<HTMLInputElement>, 'checked' | 'onChange'> {
  id?: string;
  isOn?: boolean;
  label?: string;
  onChange?: (isOn: boolean) => void;
}

const Switch: FC<Props> = ({disabled, id, isOn, label, onChange, ...rest}) => {
  id = id || Math.random().toString(36).substring(2);

  const onChangeCb = useCallback(
    (e: ChangeEvent<HTMLInputElement>) => {
      onChange?.(e.currentTarget.checked);
    },
    [onChange],
  );

  return (
    <div
      className={classNames(
        'Switch',
        styles.Switch,
        disabled && styles.disabled,
      )}
    >
      {label ? <span className={styles.label}>{label}</span> : null}
      <div className={styles.container}>
        <input
          {...rest}
          checked={isOn}
          disabled={disabled}
          id={id}
          onChange={onChangeCb}
          type="checkbox"
        />
        <label htmlFor={id} />
      </div>
    </div>
  );
};

export default memo(Switch);
